import React from 'react'
import { Container, Row } from 'reactstrap'
import PurchaseCalender from './PurchaseCalender'


export default function WeeklyBooking() {
    return (
        <>
            <Container className='manager-card' fluid>
                <Row>
                  
                    <PurchaseCalender/>
               
                </Row>
            </Container>
        </>
    )
}